import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { Typography } from '@naf-simba/building-blocks-typography';

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: ${spacing.space16};

  p {
    margin: 0 0 ${spacing.space4} 0;
  }

  @media (max-width: ${breakpoints.s}) {
    button {
      width: 100%;
    }
  }
`;

export const VehicleData = styled(Typography)`
  && {
    font-weight: bold;
  }
`;

export const DateRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${spacing.space16};

  @media (max-width: ${breakpoints.s}) {
    display: block;
  }
`;

export const DueText = styled(Typography)`
  && {
    margin: 0 ${spacing.space4} 0 0;

    @media (max-width: ${breakpoints.s}) {
      display: inline;
    }
  }
`;

export const DateText = styled(Typography)`
  && {
    font-weight: bold;

    @media (max-width: ${breakpoints.s}) {
      display: inline;
    }
  }
`;
